// WholesalerList.tsx
import React, { useEffect } from "react";
import { DataTable } from "../../../DataTable/DataTable";
import { Edit, Trash } from "lucide-react";
import { WholesalerData } from "./types";
import toast from "react-hot-toast";
import { InverntroyService } from "../../../../services/api/inventroy.service";

interface WholesalerListProps {
  searchTerm?: string;
  setSelectedWholesaler: (data:WholesalerData)=> void
  setShowWholesalerModal: ()=> void
}

const WholesalerList: React.FC<WholesalerListProps> = ({ searchTerm,setSelectedWholesaler,setShowWholesalerModal }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalItemsCount, setTotalItemsCount] = React.useState(0);
  const [wholesalerData, setWholesalerData] = React.useState<WholesalerData[]>(
    []
  );

  const loadWholesalerData = async (
    page: number,
    pageSize: number, 
    searchTerm?: string
  ) => {
    try {
      setIsLoading(true);
      const response = await InverntroyService.getWholeSalerListing(
        page,
        pageSize,
        searchTerm
      );
      if (response.success) {
        // toast.success(response.message);
        setWholesalerData(response.data);
      } else {
        toast.error(response.message);
        setWholesalerData([]);
      }
      setTotalItemsCount(response.pagination.totalItemsCount);
      setTotalPages(response.pagination.totalPages);
    } catch (error) {
      toast.error(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadWholesalerData(currentPage, pageSize, searchTerm);
  }, [currentPage, pageSize, searchTerm]);

  const handleDelteWholeSaler = async (id: string) => {
    try {
      const response = await InverntroyService.deleteWholeSaler(id);

      if (response.success) {
        toast.success(response.message);
        loadWholesalerData(1, 10);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const columns = [
    {
      key: "WholesalerName",
      title: "Wholesaler Name",
      width: "w-[200px]",
      render: (item: WholesalerData) => (
        <div
          className="flex items-center space-x-2 line-clamp-2 cursor-default"
          title={item.name}
        >
          {item.name || "N/A"}
        </div>
      ),
    },
    {
      key: "PhoneNumber",
      title: "Phone Number",
      width: "w-[150px]",
      render: (item: WholesalerData) => (
        <div className="flex items-center space-x-2">
          {item.mobile_number || "N/A"}
        </div>
      ),
    },
    {
      key: "Email",
      title: "Email",
      width: "w-[150px]",
      render: (item: WholesalerData) => (
        <div className="flex items-center space-x-2">
          {item.email || "N/A"}
        </div>
      ),
    },
    {
      key: "Address",
      title: "Address",
      width: "w-[250px]",
      render: (item: WholesalerData) => (
        <div
          className="flex items-center space-x-2 line-clamp-2 cursor-default"
          title={item.address}
        >
          {item.address || "N/A"}
        </div>
      ),
    },
    {
      key: "GSTIN",
      title: "GSTIN",
      width: "w-[150px]",
      render: (item: WholesalerData) => (
        <div className="flex items-center space-x-2">{item.gstin || "N/A"}</div>
      ),
    },
    {
      key: "DL",
      title: "DL",
      width: "w-[150px]",
      render: (item: WholesalerData) => (
        <div className="flex items-center space-x-2">
          {item.dl_number || "N/A"}
        </div>
      ),
    },
    {
      key: "FOODLIC",
      title: "Food Lic",
      width: "w-[150px]",
      render: (item: WholesalerData) => (
        <div className="flex items-center space-x-2">
          {item.food_lic_number || "N/A"}
        </div>
      ),
    },
    {
      key: "Actions",
      title: "Actions",
      width: "w-[150px]",
      render: (item: WholesalerData) => (
        <div className="flex space-x-4">
          <button
            className="text-yellow-500 hover:text-yellow-700"
            onClick={() => {
              setSelectedWholesaler(item);
              setShowWholesalerModal();
            }}
          >
            <Edit className="w-5 h-5" />
          </button>
          <button
            className="text-red-500 hover:text-red-700"
            onClick={() => {
              handleDelteWholeSaler(item.id);
            }}
          >
            <Trash className="w-5 h-5" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <DataTable
        data={wholesalerData}
        columns={columns}
        isLoading={isLoading}
        customFilters={[]}
        pagination={{
          currentPage,
          setCurrentPage,
          setTotalPages,
          totalPages,
          totalItemsCount,
          pageSize,
          setPageSize,
        }}
      />
    </div>
  );
};

export default WholesalerList;
